import { takeLatest, all, call, put } from 'redux-saga/effects';

import api from '../../../services/api';
import AuthService from '../../../services/auth';
import history from '../../../services/history';

import { authSuccess, authFailure } from './actions';

import AuthTypes from './types';

export function* signIn({ payload }) {
  try {
    const { usuario, senha } = payload;

    const response = yield call(AuthService.login, { usuario, senha });

    const authReponse = response.data;

    api.defaults.headers.Authorization = `${authReponse.token}`;
    AuthService.setAuth(authReponse.token);
    yield put(authSuccess(authReponse));

    history.push('/');
  } catch (e) {
    yield put(authFailure());
  }
}

export function setToken({ payload }) {
  if (!payload) return;
  const { token } = payload.auth;
  if (token) {
    api.defaults.headers.Authorization = `${token}`;
  }
}

export function signOut() {
  AuthService.clearAuth();
  history.push('/');
}

export default all([
  takeLatest('persist/REHYDRATE', setToken),
  takeLatest(AuthTypes.AUTH_REQUEST, signIn),
  takeLatest(AuthTypes.AUTH_LOGOUT, signOut),
]);